import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import { externalLinksProductExperienceId } from 'util/analytics/ufo/ufo';

export const externalLinksProductExperience = new UFOExperience(externalLinksProductExperienceId, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});
